import { render, staticRenderFns } from "./MerchantAutonomy.vue?vue&type=template&id=b209c4e4&scoped=true&"
import script from "./MerchantAutonomy.vue?vue&type=script&lang=js&"
export * from "./MerchantAutonomy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b209c4e4",
  null
  
)

export default component.exports